import { format } from 'date-fns';
import {
  InfoIcon,
  IconWrapper,
  LabelContainer,
  ConfirmButtonBox,
} from './bookNewSessionTabStyled';
import Button from '@mui/material/Button';
import { dateFormatYMD } from 'constants';
import { ButtonSpinner } from 'components/Ui/styled';
import { ButtonSpinnerProgress } from 'components/Ui/styled';

export const StatusLabel = ({ icon, text, message }) => {
  return (
    <LabelContainer component="span">
      <IconWrapper>{icon}</IconWrapper>
      {text}
      {message && <InfoIcon title={message}>ⓘ</InfoIcon>}
    </LabelContainer>
  );
};

export const getSubjectName = (subjects, subjectId) => {
  if (!subjectId) return '';

  const found = subjects?.find((s) => s.subjectId === subjectId);

  return found?.name || subjectId;
};

export const formatDisplayDate = (date) => {
  if (!date) return '';
  try {
    return format(new Date(date), dateFormatYMD);
  } catch {
    return date;
  }
};

export const ConfirmSubmitButton = ({
  onSubmit,
  handleSubmit,
  loading = false,
  isBooked = false,
  cancelText = 'Confirm Cancel',
  confirmText = 'Confirm Booking',
}) => {
  return (
    <ButtonSpinner>
      <ConfirmButtonBox>
        <Button
          variant="text"
          onClick={handleSubmit(onSubmit)}
          disabled={loading}
        >
          {isBooked ? cancelText : confirmText}
        </Button>

        {loading && <ButtonSpinnerProgress size={24} />}
      </ConfirmButtonBox>
    </ButtonSpinner>
  );
};
